import { AxiosResponse } from "axios";
import axiosInstance from "../../api";
import suggestiveInputHelpers from "../helpers/suggestiveInputHelpers";

function ICDCodeSideEffect(
  token: string,
  testType: string,
  setSuggestions: (response: AxiosResponse) => any
) {
  axiosInstance
    .get(`v1/test-type/${testType}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (response.data.data) {
        setSuggestions(
          response.data.data
            .sort(suggestiveInputHelpers.sortByAlphabeticalOrder)
            .map((item: any) => ({
              label: `${item.value} ${item.name}`,
              value: item.id,
            }))
        );
      }
    });
}

export default ICDCodeSideEffect;
